import React, { useState, useContext, useCallback } from "react"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import {
  showProductInfoPanel,
  setProductItemLoaded,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import ModalConfig from "components/Stacker/config/ModalConfig"
import PropTypes from "prop-types"
import queryString from "query-string"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"
import SelectButton from "../../Common/SelectButton/SelectButton"
import "./ProductItem.scss"
import { StackerContext } from "components/DYStackers/StackerContext"
import iconInfo from "assets/temp/icon-info.svg"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import { useDispatch } from "react-redux"

const isProductInQuery = (location, productId) => {
  const queryObj = queryString.parse(location.search, { decode: true })
  let queryProducts = []
  if (queryObj.products) {
    queryProducts = Array.isArray(queryObj.products)
      ? queryObj.products.map((product) => product.replace(/-/, " "))
      : [queryObj.products.replace(/-/, " ")]
  }
  return queryProducts.includes(productId)
}

function ProductItem({ maxItems, product, selected, src, style }) {
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const stackerContext = useContext(StackerContext)

  const onProductClick = useCallback(
    (code) => {
      code = code.replace("-", " ")
      const queryObj = queryString.parse(location.search, { decode: true })
      const addedStack = Array.isArray(queryObj.products)
        ? queryObj.products
        : [queryObj.products]

      const isRemove = addedStack.includes(code)
      if (addedStack.length === maxItems && !isRemove) {
        dispatch(toggleModal(ModalConfig.MODAL_STACKER_AMOUNT, true))
        return
      }

      if (isRemove) {
        stackerContext.getInstance().onItemsUnstacked([code])
      } else {
        stackerContext.getInstance().onItemStacked(code)
      }

      const productIdStack = !addedStack.includes(code)
        ? [...addedStack, code]
        : [
            ...addedStack.filter((item) => {
              return item !== code
            }),
          ]

      const queryParamsString = queryString.stringify(
        { ...queryObj, products: productIdStack },
        { encode: true }
      )
      //dispatch(push(`${location.pathname}?${queryParamsString}`));
      navigate(`${location.pathname}?${queryParamsString}`)
    },
    [
      location.search,
      location.pathname,
      maxItems,
      navigate,
      dispatch,
      stackerContext,
    ]
  )

  const onProductInfoClick = useCallback(
    (e) => {
      const { pid, url, title, description } = e.currentTarget.dataset
      e.stopPropagation()
      dispatch(
        showProductInfoPanel({
          pid,
          url,
          title,
          description: { __html: description },
        })
      )
    },
    [dispatch]
  )

  const onImageLoaded = useCallback(() => {
    if (!isImageLoaded) {
      dispatch(setProductItemLoaded())
    }
    setIsImageLoaded(true)
  }, [dispatch, isImageLoaded])

  // Force selected state based on querystring
  // Will also sync stacker actions with product list
  selected = isProductInQuery(location, product.code)
  const buttonClass = classNames("btn", "product_stacker-btn", {
    selected: selected,
  })

  return (
    <div className="product_stacker product_list-item" style={style}>
      <button
        className={buttonClass}
        onClick={() => onProductClick(product.code.replace(/ /, "-"))}
      >
        <div className="product_list-item-border" />
        <img
          alt={product.baseProduct}
          src={src}
          width="100%"
          onLoad={onImageLoaded}
        />
      </button>

      {selected && (
        <React.Fragment>
          <button
            className="btn btn-info-circle"
            data-description={product.meaning_short}
            data-pid={product.baseProduct}
            data-url={product.url}
            data-title={product.rawTitle}
            onClick={onProductInfoClick}
          >
            <InlineSVGIcon iconSvgText={iconInfo} />
          </button>
          <SelectButton
            className="product_stacker-button_selected"
            selected={selected}
          />
        </React.Fragment>
      )}
    </div>
  )
}

export default ProductItem

ProductItem.propTypes = {
  maxItems: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  style: PropTypes.object,
}
